import { mercafacilThemeColors } from '@/config/mercafacilThemeColors'

export function resolveThemeColor(color) {
  if (!color) return color

  const normalized = color.trim()

  if (normalized.startsWith('#') || normalized.startsWith('rgb')) {
    return normalized
  }

  return mercafacilThemeColors[normalized] || `rgb(var(--v-theme-${normalized}))`
}
